import React, { Component } from "react";

import "./LoadingThrobber.css";

export default class LoadingThrobber extends Component {

  render() {
    return (

      <div className="throbber">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>

    );
  }

}



// WEBPACK FOOTER //
// ./src/components/LoadingThrobber.js